import Vue from 'vue'
import orUI from '@onereach/ui'
import App from './App'
import Vuelidate from 'vuelidate'
import VueShortKey from 'vue-shortkey'
import VueRouter from 'vue-router'
import router from '@/router/router'
import store from './store/index'
import { i18n } from './i18n/setup'
import VueCompositionAPI from '@vue/composition-api'

import 'normalize.css/normalize.css'
import 'material-design-icons/iconfont/material-icons.css'
import 'keen-ui/dist/keen-ui.css'
import '@onereach/ui/dist/or-ui.css'

import VueDirectiveMarkdown from 'vue-directive-markdown'

Vue.directive('md', VueDirectiveMarkdown)

Vue.use(orUI)
Vue.use(Vuelidate)
Vue.use(VueRouter)
Vue.use(VueShortKey)
Vue.use(VueCompositionAPI)

Vue.config.productionTip = false

new Vue({
  i18n,
  router,
  store,
  render: h => h(App)
}).$mount('#kbase')
